export default "__VITE_ASSET__DM4_YjYe__"